import { render, staticRenderFns } from "./createTicket.vue?vue&type=template&id=5c5edfaf&scoped=true&"
import script from "./createTicket.vue?vue&type=script&lang=js&"
export * from "./createTicket.vue?vue&type=script&lang=js&"
import style0 from "./createTicket.vue?vue&type=style&index=0&id=5c5edfaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5edfaf",
  null
  
)

export default component.exports